import React from 'react';
import { connect } from '../../redux/store';
import { Card, CardCol, CardRow, TimeAgo } from '@kineticdata/bundle-common';
import { Link } from '@reach/router';
import { I18n } from '@kineticdata/react';
import {
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from 'reactstrap';

export const SurveyCard = connect(state => ({
  mobile: state.app.layoutSize === 'small',
}))(props => {
  const { submission, username, appLocation, navigate, path } = props;
  const form = submission.form;
  const allowOptOut = JSON.parse(
    submission.form['attributesMap']['Survey Configuration'],
  )['Allow Opt-out'];

  return (
    <Card to={path} components={{ Link }}>
      <CardRow>
        <CardRow type="prepend" className="text-muted">
          <span className={`fa fa-fw fa-2x fa-pen-square`} />
        </CardRow>
        <CardCol>
          <CardRow className="text-muted">
            <span>
              <strong>
                <I18n>{form.name}</I18n>
              </strong>
              {' \u00b7 '}
              {submission.handle}
            </span>
          </CardRow>
          <CardRow type="subtitle">
            <I18n>{submission.label}</I18n>
          </CardRow>
          <CardRow type="meta" className="text-muted">
            <dl className="flat">
              {[
                submission.values['rence Id'] && {
                  label: 'Reference Id',
                  value: submission.values['Reference Id'],
                },
                {
                  label: 'Initiated',
                  value: <TimeAgo timestamp={submission.createdAt} />,
                },
                submission.values['Due Date'] && {
                  label: 'Due',
                  value: <TimeAgo timestamp={submission.values['Due Date']} />,
                },
              ]
                .filter(Boolean)
                .map(({ label, value }, i) => (
                  <div key={`meta-${i}`}>
                    {label && (
                      <dt>
                        <I18n>{label}</I18n>
                      </dt>
                    )}
                    {value && <dd>{value}</dd>}
                  </div>
                ))}
            </dl>
          </CardRow>
        </CardCol>
        {!props.mobile &&
          allowOptOut && (
            <CardRow type="append">
              <UncontrolledDropdown className="actions-dropdown">
                <DropdownToggle
                  color="outline-dark"
                  onClick={e => e.preventDefault()}
                >
                  <span>
                    <I18n>Actions</I18n>
                  </span>
                  <span className="ml-1 fa fa-fw fa-angle-down" />
                </DropdownToggle>
                <DropdownMenu right>
                  <DropdownItem
                    onClick={e => {
                      e.preventDefault();
                      navigate(
                        `${appLocation}/${
                          submission.form.slug
                        }/survey-opt-out?values[recipientEmail]=${username}`,
                      );
                    }}
                  >
                    <I18n>Unsubscribe</I18n>
                  </DropdownItem>
                </DropdownMenu>
              </UncontrolledDropdown>
            </CardRow>
          )}
      </CardRow>
    </Card>
  );
});
